import { engineComponent } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { ContainerElement } from "../../Components/Elements/Graphics/ContainerElement";
import { BaseController } from "./BaseController";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../Utils/FrameTimer";
import { Symbols } from "../Symbols";
import { Machine } from "../Machine";
import { StageController } from "../../Components/StageController";
import { WinAnimator } from "../WinAnimator";
import { GameManager } from "../../Managers/GameManager";
import { PlayList } from "../../Components/Sounds/PlayList";
import { Tweens } from "../../Components//Effects/Tweens";
import { ShapeElement } from "../../Components/Elements/Graphics/ShapeElement";


import { ModuleManager } from "../../Managers/ModuleManager";
import { DataManager } from "../../Managers/DataManager";
import { MachineExtended } from "../../CustomComponents/MachineExtended";
import { WinAnimatorExtended } from "../../CustomComponents/WinAnimatorExtended";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { CustomUtils } from "../../Utils/CustomUtils";
import { BonusCounters } from "../../CustomComponents/BonusCounters";
import { LayoutSwitchElement } from "../../CustomComponents/LayoutSwitchElement";
import { LayoutManager } from "../../Managers/LayoutManager";
import { LayoutContainerElement } from "../../CustomComponents/LayoutContainerElement";
import { SceneHolderElement } from "../../CustomComponents/SceneHolderElement";
import { Communication } from "neo-games";
import { AmbientBackground } from "../../Utils/AmbientBackground";

var GameModules = Communication.Game.GameModules;

@engineComponent(ComponentTypes.DisplayObject)
export class BaseView extends LayoutContainerElement {
    public static BonusCounters: BonusCounters;

    public static Messages: LayoutSwitchElement;

    public static LayoutManager: LayoutManager;

    public static stickySymbolId: number;
    public static isRespin: boolean;

    private static readonly GambleInTransitionDuration: number = 30; //in frames

    private _controller: BaseController;
    private _wasFinished: boolean = false;

    // Timers
    private _introDelay: FrameTimerEventEmitter;
    private _outroDelay: FrameTimerEventEmitter;
    private _outroFinishDelay: FrameTimerEventEmitter;

    private _symbols: Symbols;
    private _machine: MachineExtended;
    private _winAnimator: WinAnimatorExtended;

    private _respinCounter: number;

    private _background: SwitchElement;

    private _gambleTransition: SwitchElement;
    private _gambleTransitionSceneHolder: SceneHolderElement;

    private _bonusTransition: SwitchElement;
    private _bonusTransitionSceneHolder: SceneHolderElement;

    constructor() {
        super();

        this._introDelay = CreateFrameTimer("introDelay");
        this._introDelay.on(FrameTimerEvents.Complete, this.introFinished.bind(this));
        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroStart.bind(this));
        this._outroFinishDelay = CreateFrameTimer("outroFinishDelay");
        this._outroFinishDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));

        this._respinCounter = -1;
    }

    public createByNode(node: Element): void {
        super.createByNode(node);

        BaseView.LayoutManager = new LayoutManager();

        if (this.childs["Symbols"] != null) {
            this._symbols = this.childs["Symbols"];
            this.removeChild(this._symbols);
        }

        this._machine = CustomUtils.getObjectFrom("Machine", this.childs);
        this._winAnimator = CustomUtils.getObjectFrom("WinAnimator", this.childs);

        if (this.childs["Background"] != null) {
            this._background = this.childs["Background"];
        }

        if (this.childs["GambleTransition"] != null) {
            this._gambleTransition = this.childs["GambleTransition"];
            this._gambleTransitionSceneHolder = <SceneHolderElement>(
                this._gambleTransition.getChildElementByName("Scene")
            );
        }

        if (this.childs["BonusTransition"] != null) {
            this._bonusTransition = this.childs["BonusTransition"];
            this._bonusTransitionSceneHolder = <SceneHolderElement>this._bonusTransition.getChildElementByName("Scene");
        }

        if (this.childs["TopCounters"] instanceof ContainerElement) {
            const topCounters = this.childs["TopCounters"];
            BaseView.BonusCounters = <BonusCounters>topCounters.childs["BonusCounters"];
            BaseView.BonusCounters.goToCase("NORMAL");
        }

        BaseView.Messages = CustomUtils.getObjectFrom("Messages", this.childs, LayoutSwitchElement);

        this.setupGambleTransitionSceneElement();
        this.setupBonusTransitionSceneElement();
    }

    public disableLogo(): void {
        // if (this.childs['Logo'] != null) {
        //     this.removeChild(this.childs['Logo']);
        // }
    }

    public initReceived(controller: BaseController): void {
        if (DEBUG) {
            this.log("initReceived");
        }

        this._controller = controller;

        if (BaseView.BonusCounters) {
            BaseView.BonusCounters.updateCounters();
        }

        if (this._symbols != null) {
            if (this._machine != null) {
                if (GameManager.baseResponse != null) {
                    const baseInitDataReels = GameManager.getBaseInitDataReels();
                    if (baseInitDataReels != null) {
                        this._machine.on(Machine.ReelStopped, this.onReelStopped.bind(this));
                        this._machine.on(Machine.MachineStopped, this.machineStopped.bind(this));
                        this._machine.initialize(
                            this._symbols,
                            baseInitDataReels,
                            null,
                            this.childs["Teasing"],
                            GameManager.baseResponse.initData.customData.respinReels,
                            this._winAnimator,
                        );

                        // Custom for MoneyVaults
                        const baseInitDataCustomAdditionalReelSets =
                            GameManager.getBaseInitDataCustomAdditionalReelSets();
                        if (baseInitDataCustomAdditionalReelSets != null) {
                            this._machine.addAdditionalReelSets(baseInitDataCustomAdditionalReelSets);
                        }
                    } else {
                        if (DEBUG) {
                            this.log("ERROR no reels in initData");
                        }
                    }

                    if (
                        GameManager.baseResponse.screen != null &&
                        GameManager.baseResponse.screen.reels != null &&
                        GameManager.baseResponse.screen.reels.length !== 0
                    ) {
                        if (this._winAnimator != null) {
                            this._winAnimator.on(
                                WinAnimator.FinishWinCalculation,
                                this.finishWinCalculation.bind(this),
                            );
                            this._winAnimator.on(WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
                            this._winAnimator.on(
                                WinAnimatorExtended.FinishQuickWinCalculation,
                                this.finishQuickWinCalculation.bind(this),
                            );
                            this._winAnimator.on(
                                WinAnimatorExtended.StickyAnimationFinished,
                                this.machineStoppedFinished.bind(this),
                            );
                            this._winAnimator.initialize(
                                this._symbols,
                                this.childs["Paylines"],
                                this.childs["NoWinContainer"],
                                this.childs["WinContainer"],
                                this._background,
                                this.childs["PaylinesFields"],
                            );
                            this._winAnimator.initializeStickyContainer(this.childs["StickyContainer"]);
                            this._winAnimator.initializeMultiplierContainer(
                                this.childs["BigMultiplier"],
                                this.childs["TopMultipliers"],
                            );
                            this._winAnimator.showSymbols(GameManager.baseResponse.screen.reels);
                        }
                        this._machine.setStoppedSymbolsArray(GameManager.baseResponse.screen.reels);
                    } else {
                        if (DEBUG) {
                            this.log("ERROR no reels in response");
                        }
                    }
                } else {
                    if (DEBUG) {
                        this.log("ERROR no base reponse");
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no symbols");
            }
        }

        if (ModuleManager.gambleActive()) {
            this._gambleTransition.goToCase("HIDE_GAMBLE_INIT");
        } else {
            if (this._gambleTransition != null) {
                this._gambleTransition.goToCase("HIDE_GAMBLE_HYPER_INIT");
            }
        }

        if (this._bonusTransition != null) {
            this._bonusTransition.goToCase("EMPTY");
        }
    }

    public initIntro(): void {
        // if (this._gambleTransition != null) {
        //     this._gambleTransition.goToCase('SHOW_INIT');
        // }

        if (CustomUtils.isRespin()) {
            this._winAnimator.showStickySymbols();
            PlayList.loop("SND_BaseRespinLoop");
        } else {
            if (GameManager.gameResponse.totalWin > 0) {
                PlayList.loop("SND_BaseRecapLoop");
            } else {
                PlayList.resetVolume("SND_BaseLoop");
                PlayList.loop("SND_BaseLoop");
            }
            this._winAnimator.showStickySymbols();
            this._winAnimator.showInitWins(GameManager.baseResponse.wins, GameManager.baseResponse.currentWin);
        }

        if (BaseView.Messages != null) {
            if (ModuleManager.bonusEnabled()) {
                PlayList.play("SND_BaseMessage");
                BaseView.Messages.goToCase("SHOW");
            }
        }
    }

    public collect(): void {
        PlayList.stop("SND_BaseRecapLoop");
        PlayList.resetVolume("SND_BaseLoop");
        PlayList.loop("SND_BaseLoop");

        this._respinCounter = 0;

        this._winAnimator.resetMultiplierContainer();

        this._winAnimator.reset(true);
    }

    public spin(spinBitmask: number): void {
        PlayList.stop("SND_BaseRecapLoop");
        PlayList.stop("SND_BaseRespinLoop");
        PlayList.resetVolume("SND_BaseLoop");
        PlayList.loop("SND_BaseLoop");

        BaseView.stickySymbolId = -1;

        this._respinCounter = 0;
        BaseView.isRespin = false;

        this._winAnimator.resetMultiplierContainer();

        this._machine.spinStart(
            this._winAnimator.reset(true, true),
            true,
            this._winAnimator.currentSymbols,
            spinBitmask,
        );
    }

    respin(spinBitmask: number): void {
        this._respinCounter++;
        BaseView.isRespin = true;

        PlayList.stop("SND_BaseRecapLoop");
        PlayList.setVolume("SND_BaseLoop", 0);
        if (this._respinCounter === 1) {
            if (this._background) {
                this._background.goToCase("RESPIN");
            }
            PlayList.loop("SND_BaseRespinLoop");
        }

        this._winAnimator.resetStickySymbols();
        this._machine.spinStart(
            this._winAnimator.reset(true, true),
            true,
            this._winAnimator.currentSymbols,
            spinBitmask,
        );
    }

    public stop(): void {
        this._machine.spinStop(null, true);
    }

    public spinReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.baseResponse.screen.reels);
        this._machine.spinStop(null, false, true);
    }

    public onReelStopped(force: boolean = false): void {
        this._winAnimator.onReelStopped(
            GameManager.baseResponse.screen.reels,
            this._machine.actualReelStopped,
            this._gambleTransition,
            force,
        );
        if (BaseView.isRespin && this._winAnimator.hasStickySymbol(this._machine.actualReelStopped)) {
            this._winAnimator.addStickySymbols(this._machine.actualReelStopped);
        }
    }

    public machineStopped(): void {
        if (CustomUtils.isRespin() && this._winAnimator.hasSticky()) {
            if (!BaseView.isRespin) {
                for (let i = 0; i < this._winAnimator.getReelCount(); i++) {
                    this._winAnimator.addStickySymbols(i);
                }
            }
            this._winAnimator.startStickyDelay();
            // if there is Sticky Symbol, make STOP button inactive until animation ends - emit in BaseController, listener in DesktopBaseUserControls
            this._controller.machineStoppedWithAnimation();
        } else {
            if (GameManager.gameResponse.totalWin > 0) {
                this.machineStoppedFinished();
            } else {
                this.machineStoppedFinished();
            }
        }
    }

    public machineStoppedFinished(): void {
        this._wasFinished = false;
        this._controller.machineStopped(
            this._winAnimator.showWins(
                GameManager.baseResponse.wins,
                GameManager.baseResponse.currentWin,
                this._bonusTransition,
            ),
        );
    }

    private finishQuickWinCalculation(): void {
        this._controller.quickWinCalculationFinished();
    }

    private finishWinCalculation(): void {
        this._wasFinished = true;
        this._controller.winCalculationFinished();
    }

    private finishWinAnimator(): void {
        if (!DataManager.Autoplay) {
            PlayList.setVolume("SND_BaseLoop", 0);
            PlayList.stop("SND_BaseRespinLoop");
            PlayList.loop("SND_BaseRecapLoop");
        } else {
            PlayList.stop("SND_BaseRespinLoop");
            PlayList.resetVolume("SND_BaseLoop");
            PlayList.loop("SND_BaseLoop");
        }

        if (BaseView.Messages != null) {
            if (ModuleManager.bonusEnabled()) {
                PlayList.play("SND_BaseMessage");
                BaseView.Messages.goToCase("SHOW");
            }
        }

        this._controller.allWinsFinished();
    }

    public resetWinAnimator(): void {
        this._winAnimator.reset(true);
    }

    public intro(long: boolean = false, previousModule: string): void {
        this.visible = true;

        if (BaseView.BonusCounters != null && this.childs["TopCounters"] != null) {
            this.childs["TopCounters"].addChild(BaseView.BonusCounters);
        }

        if (long) {
            if (previousModule === GameModules.Gamble && this._gambleTransition != null) {
                this._gambleTransition.goToCase("SHOW");
            } else if (previousModule === GameModules.BonusRespins && this._bonusTransition != null) {
                // this._bonusTransition.setDynamicTime(0);
                this._bonusTransition.goToCase("SHOW");
            }

            this._introDelay.start(15);
        } else {
            this.introFinished();
        }
    }

    private introFinished(): void {
        if (GameManager.gameResponse.totalWin > 0) {
            PlayList.stop("SND_BaseRespinLoop");
            PlayList.loop("SND_BaseRecapLoop");
        } else {
            PlayList.stop("SND_BaseRecapLoop");
            PlayList.resetVolume("SND_BaseLoop");
            PlayList.loop("SND_BaseLoop");
        }

        if (BaseView.Messages != null) {
            if (ModuleManager.bonusActive()) {
                PlayList.play("SND_BaseMessage");
                BaseView.Messages.goToCase("SHOW");
            }
        }

        this._controller.introFinished();
    }

    public outro(): void {
        StageController.baseStage = true;

        PlayList.stop("SND_BaseLoop", 5);
        PlayList.stop("SND_BaseRecapLoop", 5);
        PlayList.stop("SND_BaseRespinLoop", 15);

        // TODO try to understand
        if (ModuleManager.bonusActive()) {
            this.outroToBonus();
        } else {
            this.outroToGamble();
        }
    }

    private outroToBonus(): void {
        PlayList.stop("SND_BonusWait");
        if (this._bonusTransition != null) {
            this._bonusTransition.goToCase("BONUS_INTRO");
            PlayList.play("SND_BonusTransition");
        }
        this._outroDelay.start(30);

        if (ModuleManager.bonusActive()) {
            if (BaseView.Messages != null) {
                BaseView.Messages.goToCase("HIDE");
            }
        }
    }

    private outroToGamble(): void {
        const inHighWins = this._winAnimator.reset(true);

        if (this._wasFinished) {
            this.outroStart();
        } else {
            if (inHighWins) {
                this._outroDelay.start(60);
            } else {
                this._outroDelay.start(30);
            }
        }
    }

    private outroStart(): void {
        if (ModuleManager.bonusActive()) {
            // if (BaseView.Messages != null) {
            //     BaseView.Messages.goToCase('HIDE');
            // }
            AmbientBackground.changeAmbientBackground("bonus", 180, 105);
            this._outroFinishDelay.start(120);
        } else {
            PlayList.play("SND_GambleTransitionIn");
            if (this._gambleTransition != null) {
                this._gambleTransition.goToCase("HIDE_GAMBLE");
            }

            this._outroFinishDelay.start(30);
        }
    }

    outroFinished(): void {
        this._outroFinishDelay.stop();

        this._winAnimator.reset(true);

        this._controller.outroFinished();
    }

    selectPayline(): void {}

    disableBase(): void {
        this._winAnimator.resetTimer();
    }

    resetScreen(): void {
        if (this._winAnimator) {
            this._winAnimator.showSymbols(GameManager.baseResponse.screen.reels);
        }

        if (this._machine) {
            this._machine.spinReset();
            this._machine.setStoppedSymbolsArray(GameManager.baseResponse.screen.reels);
        }

        const node = document.createElement("ResetOverlay");
        node.setAttribute("width", StageController.Width.toString());
        node.setAttribute("height", StageController.Height.toString());
        node.setAttribute("color", "000000");
        const resetOverlay = new ShapeElement();
        resetOverlay.create(node);

        this.addChild(resetOverlay);
        Tweens.removeTweens(resetOverlay, "alpha");
        Tweens.alphaTween(resetOverlay, {
            alphas: [1, 0],
            tweenDuration: 10,
            callbackFunction: () => {
                resetOverlay.destroy();
            },
        });

        PIXI.sound.unmuteAll();
        PlayList.stopAll();

        this.initIntro();
    }

    toggleSounds(enable: boolean): void {
        if (enable) {
            PlayList.loop("SND_BaseLoop");
        } else {
            PlayList.stop("SND_BaseLoop");
            PlayList.stop("SND_BaseRecapLoop");
        }
    }

    public changeBet(): void {
        if (BaseView.BonusCounters != null) {
            BaseView.BonusCounters.updateCounters();
        }
    }

    //******************************************************************************************************************
    //  ADDITIONAL
    //******************************************************************************************************************

    private setupGambleTransitionSceneElement(): void {
        this._gambleTransitionSceneHolder.addElement({
            element: this.childs["Reels"],
            parent: this,
            index: this.getChildIndex(this.childs["Reels"]),
        });
        this._gambleTransitionSceneHolder.addElement({
            element: this.childs["TopCounters"],
            parent: this,
            index: this.getChildIndex(this.childs["TopCounters"]),
        });
        this._gambleTransitionSceneHolder.addElement({
            element: this.childs["LineBottom"],
            parent: this,
            index: this.getChildIndex(this.childs["LineBottom"]),
        });
        this._gambleTransitionSceneHolder.addElement({
            element: this.childs["Machine"],
            parent: this,
            index: this.getChildIndex(this.childs["Machine"]),
        });
        this._gambleTransitionSceneHolder.addElement({
            element: this.childs["NoWinContainer"],
            parent: this,
            index: this.getChildIndex(this.childs["NoWinContainer"]),
        });
        this._gambleTransitionSceneHolder.addElement({
            element: this.childs["Paylines"],
            parent: this,
            index: this.getChildIndex(this.childs["Paylines"]),
        });
        this._gambleTransitionSceneHolder.addElement({
            element: this.childs["WinContainer"],
            parent: this,
            index: this.getChildIndex(this.childs["WinContainer"]),
        });
        this._gambleTransitionSceneHolder.addElement({
            element: this.childs["StickyContainer"],
            parent: this,
            index: this.getChildIndex(this.childs["StickyContainer"]),
        });
        this._gambleTransitionSceneHolder.addElement({
            element: this.childs["PaylinesFields"],
            parent: this,
            index: this.getChildIndex(this.childs["PaylinesFields"]),
        });
        this._gambleTransitionSceneHolder.addElement({
            element: this.childs["TopMultipliers"],
            parent: this,
            index: this.getChildIndex(this.childs["TopMultipliers"]),
        });
        this._gambleTransitionSceneHolder.addElement({
            element: this.childs["BigMultiplier"],
            parent: this,
            index: this.getChildIndex(this.childs["BigMultiplier"]),
        });
        this._gambleTransitionSceneHolder.addElement({
            element: this.childs["Teasing"],
            parent: this,
            index: this.getChildIndex(this.childs["Teasing"]),
        });
        this._gambleTransitionSceneHolder.addElement({
            element: this.childs["Logo"],
            parent: this,
            index: this.getChildIndex(this.childs["Logo"]),
        });
        this._gambleTransitionSceneHolder.addElement({
            element: this.childs["WinAnimator"],
            parent: this,
            index: this.getChildIndex(this.childs["WinAnimator"]),
        });
    }

    private setupBonusTransitionSceneElement(): void {
        this._bonusTransitionSceneHolder.addElement({
            element: this.childs["Reels"],
            parent: this,
            index: this.getChildIndex(this.childs["Reels"]),
        });
        this._bonusTransitionSceneHolder.addElement({
            element: this.childs["TopCounters"],
            parent: this,
            index: this.getChildIndex(this.childs["TopCounters"]),
        });
        this._bonusTransitionSceneHolder.addElement({
            element: this.childs["LineBottom"],
            parent: this,
            index: this.getChildIndex(this.childs["LineBottom"]),
        });
        this._bonusTransitionSceneHolder.addElement({
            element: this.childs["Machine"],
            parent: this,
            index: this.getChildIndex(this.childs["Machine"]),
        });
        this._bonusTransitionSceneHolder.addElement({
            element: this.childs["NoWinContainer"],
            parent: this,
            index: this.getChildIndex(this.childs["NoWinContainer"]),
        });
        this._bonusTransitionSceneHolder.addElement({
            element: this.childs["Paylines"],
            parent: this,
            index: this.getChildIndex(this.childs["Paylines"]),
        });
        this._bonusTransitionSceneHolder.addElement({
            element: this.childs["WinContainer"],
            parent: this,
            index: this.getChildIndex(this.childs["WinContainer"]),
        });
        this._bonusTransitionSceneHolder.addElement({
            element: this.childs["StickyContainer"],
            parent: this,
            index: this.getChildIndex(this.childs["StickyContainer"]),
        });
        this._bonusTransitionSceneHolder.addElement({
            element: this.childs["PaylinesFields"],
            parent: this,
            index: this.getChildIndex(this.childs["PaylinesFields"]),
        });
        this._bonusTransitionSceneHolder.addElement({
            element: this.childs["TopMultipliers"],
            parent: this,
            index: this.getChildIndex(this.childs["TopMultipliers"]),
        });
        this._bonusTransitionSceneHolder.addElement({
            element: this.childs["Logo"],
            parent: this,
            index: this.getChildIndex(this.childs["Logo"]),
        });
        this._bonusTransitionSceneHolder.addElement({
            element: this.childs["BigMultiplier"],
            parent: this,
            index: this.getChildIndex(this.childs["BigMultiplier"]),
        });
        this._bonusTransitionSceneHolder.addElement({
            element: this.childs["Teasing"],
            parent: this,
            index: this.getChildIndex(this.childs["Teasing"]),
        });
        this._bonusTransitionSceneHolder.addElement({
            element: this.childs["WinAnimator"],
            parent: this,
            index: this.getChildIndex(this.childs["WinAnimator"]),
        });
        this._bonusTransitionSceneHolder.addElement({
            element: this.childs["Messages"],
            parent: this,
            index: this.getChildIndex(this.childs["Messages"]),
        });
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Base/BaseView.ts
 **/